import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from "../../../environments/environment";
import { cookiesUtils } from "../../helpers/cookies.utils";
import { PlanningRegionApiService } from "../../services/api/planning-region-api.service";
import { RegionGroup } from "../../models/planning_region.model";
import {Region, Regions} from "../../models/region.model";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  homeDir = environment.homeDir;
  navItems: RegionGroup[] = [];
  isPlanningRegionOpen = false;
  isSidebarOpen = false;
  closeSidebarTimeout: any;

  constructor(
    private planningRegionApiService: PlanningRegionApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const parsedSegments = cookiesUtils.getCookiesAndRegion();

    if (parsedSegments) {
      const { idRegion, cookies } = parsedSegments;
      this.planningRegionApiService.fetchGroups(cookies).subscribe((regions: Regions) => {
        this.navItems = this.createNavItems(regions, cookies);
      }, error => {
        console.log(error);
      });
    }
  }

  createNavItems(data: Regions, cookies: string): RegionGroup[] {
    const navItems: RegionGroup[] = [];
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        data[key].forEach((group: Region) => {
          navItems.push({
            id_region: group.id_group,
            label: group.nom_group,
            path: `#/planning-region/${group.id_group}/${cookies}`
          });
        });
      }
    }
    return navItems;
  }

  togglePlanningRegion() {
    this.isPlanningRegionOpen = !this.isPlanningRegionOpen;
  }

  toggleSidebarHover(isHover: boolean): void {
    if (isHover) {
      clearTimeout(this.closeSidebarTimeout);
      this.isSidebarOpen = true;
    } else {
      this.closeSidebarTimeout = setTimeout(() => {
        this.isSidebarOpen = false;
        this.closePlanningRegion();
      }, 200);
    }
  }

  private closePlanningRegion(): void {
    this.isPlanningRegionOpen = false;
  }

  navigateTo(url: string): void {
    window.location.href = url;
  }

  changeRegion(url: string): void {
    const regionId = parseInt(url.split('/').slice(-2, -1)[0], 10);
    this.planningRegionApiService.reloadPlanningRegion(regionId);
    window.location.href = url;
  }

  isActive(path: string): boolean {
    return this.router.url === path.replace('#', '');
  }
}
